module.exports = __webpack_public_path__ + "eb45b0e55b480d85f5fd799b4a843ce6.png";